import WVFormatter from '../../../../../../shared/helpers/WVFormatter';

export default (props) => {
  const { record } = props;
  const currency = record.params['impactAction.currency'] || 'USD';
  return typeof record.params.deltaPayout !== 'undefined' && record.params.deltaPayout !== null ?
    WVFormatter.formatCurrency(record.params.deltaPayout, currency) : '';
};
